import './Flags.scss';

import cn from 'classnames';
import React from 'react';

import { FlagsDefaultProps, FlagsPropTypes } from './Flags.proptypes';

const Flags = ({ className, flags }) => {
  if (flags && flags.length > 0) {
    return (
      <ul className={cn('flags', className)} data-qa-id="flags">
        {flags.map(
          (flag) =>
            !Array.isArray(flag) && (
              <li
                className={`flag flag--${flag.slug}`}
                data-qa-id="flag"
                data-qa-value={`flag-${flag.slug}`}
                key={`flag-${flag.slug}`}
                style={
                  flag.slug === 'discount-class'
                    ? { border: `1px solid ${flag.color}` }
                    : { backgroundColor: flag.color }
                }
              >
                <span
                  className="flag__item"
                  style={{
                    color:
                      flag.slug === 'discount-class' ? flag.color : 'white',
                  }}
                >
                  {flag.label}
                </span>
              </li>
            ),
        )}
      </ul>
    );
  }

  return null;
};

Flags.defaultProps = {
  ...FlagsDefaultProps,
};

Flags.propTypes = {
  ...FlagsPropTypes,
};

export default Flags;
